export const MODAL_TYPES = {
  LOCKED_MODAL: 'LOCKED_MODAL',
  DELETE_MODAL: 'DELETE_MODAL',
  CLONE_CONTENT_MODAL: 'CLONE_CONTENT_MODAL',
  CREATE_CONTENT_MODAL: 'CREATE_CONTENT_MODAL',
  CONVERT_TO_DD_MODAL: 'CONVERT_TO_DD_MODAL',
  SAVE_TEMPLATE_MODAL: 'SAVE_TEMPLATE_MODAL',
  CONFIRM_EDIT_GLOBAL: 'CONFIRM_EDIT_GLOBAL',
  CONFIRM_EDIT_EMBED: 'CONFIRM_EDIT_EMBED',
  FORCE_IFRAME_HIDE: 'FORCE_IFRAME_HIDE',
  EMAIL_CUSTOM_ONBOARDING_MODAL: 'EMAIL_CUSTOM_ONBOARDING_MODAL',
  EMAIL_TRUE_SIZE_MODAL: 'EMAIL_TRUE_SIZE_MODAL',
  SAVE_SECTION_MODAL: 'SAVE_SECTION_MODAL',
  VIDEO_UPGRADE_PQL: 'VIDEO_UPGRADE_PQL',
  CART_MODULE_PQL: 'CART_MODULE_PQL',
  PRODUCTS_MODULE_PQL: 'PRODUCTS_MODULE_PQL',
  MANAGE_ACCESS: 'MANAGE_ACCESS',
  MANAGE_SAVED_SECTIONS: 'MANAGE_SAVED_SECTIONS',
  EDIT_ECOMM_PRODUCT: 'EDIT_ECOMM_PRODUCT',
  CREATE_SIMPLE_WORKFLOW: 'CREATE_SIMPLE_WORKFLOW',
  ADD_TO_WORKFLOW_AFTER_PUBLISH: 'ADD_TO_WORKFLOW_AFTER_PUBLISH',
  FILE_MANAGER: 'FILE_MANAGER',
  SETTINGS_MODAL: 'SETTINGS_MODAL',
  SECTIONS_INSTRUCTIONAL_MODAL: 'SECTIONS_INSTRUCTIONAL_MODAL',
  TRANSLATE_CONTENT_ACTION_MODAL: 'TRANSLATE_CONTENT_ACTION_MODAL',
  CREATE_MLANG_VARIANT: 'CREATE_MLANG_VARIANT',
  MLANG_LIMIT_UPGRADE_MODAL: 'MLANG_LIMIT_UPGRADE_MODAL',
  PROGRAMMABLE_EMAIL_LIMITS_MODAL: 'PROGRAMMABLE_EMAIL_LIMITS_MODAL',
  REPLY_TO_UNVERIFIED_ADDRESSES_MODAL: 'REPLY_TO_UNVERIFIED_ADDRESSES_MODAL',
  SPOTLIGHT: 'SPOTLIGHT',
  CONTENT_REMIX: 'CONTENT_REMIX',
  CONTENT_REMIX_POST_PUBLISH: 'CONTENT_REMIX_POST_PUBLISH',
  AILP_THANK_YOU_PAGE_REMINDER: 'AILP_THANK_YOU_PAGE_REMINDER',
  CUSTOMER_AGENT_POST_PUBLISH: 'CUSTOMER_AGENT_POST_PUBLISH'
};
export const TEST_MODAL_TYPES = {
  AB_TEST: 'ab',
  MAB_TEST: 'mab'
};
export const NO_TEST_ACCESS = 'noAccess';
export const SMART_CONTENT = 'smartContent';
export const AB_TEST = 'ab';